import DateRangePickerWithInputs from '../../../Common/date-range-picker-with-inputs/date-range-picker-with-inputs.component';
import './date-range.filter-type.scss';

const DateRangeFilterType = ({
  item,
  onFilterChange,
  setDateSelectionValue,
  selectedDateFilter,
  staticRanges,
  filterList,
  dateFormat
}) => {
  const handleDateChange = (range) => {
    setDateSelectionValue(range);
    onFilterChange(filterList.map(f => {
      if (f.key === item.key) {
        return {
          ...f,
          value: range
        };
      }
      return f;
    }), {
      ...item,
      value: range
    });
  };

  return (
    <div className='date-filter-dropdown dashboardDateFilter'>
      <div className='dropdown-menu show menu p-0'>
        <DateRangePickerWithInputs
          startDate={selectedDateFilter?.startDate}
          endDate={selectedDateFilter?.endDate}
          onDateChange={handleDateChange}
          staticRanges={staticRanges}
          editableDateInputs={true}
          direction="vertical"
          startDatePlaceholder="From"
          endDatePlaceholder="To"
          dateFormat={dateFormat}
        />
      </div>
    </div>
  );
};

export default DateRangeFilterType;
